const entityAnnotationMarkers = {
	start: '\uE000rovo-entity:',
	end: '\uE001',
	endMarker: '\uE000rovo-entity:end\uE001',
};

export default entityAnnotationMarkers;
